import './styles.scss'

import React from 'react'
import { useValues } from 'kea'

import I18n from 'lib/i18n'

import Map from './map-pigeon'
import List from './list'

import courseShowLogic from '~/scenes/course/show/logic'

const Locations = () => {
  const {
    course: { locations }
  } = useValues(courseShowLogic)
  const showMap = locations && locations.some(location => location.type !== 'webcam')
  let _setMapLocation

  const handleMapLoad = setMapLocation => {
    _setMapLocation = setMapLocation
  }

  const handleListClick = location => {
    if (_setMapLocation && typeof location.latitude !== 'undefined' && typeof location.longitude !== 'undefined') {
      _setMapLocation(location)
    }
  }

  return (
    <div>
      <h2>{I18n.t('courses.show.location')}</h2>
      <List onClick={handleListClick} />
      <br />
      {showMap ? <Map onLoaded={handleMapLoad} /> : null}
    </div>
  )
}

export default Locations
